import { useEffect, useRef, useState } from 'react';

export function EllipsedTextWithTooltip({
  className = '',
  text,
  delay = 'delay-100',
}: {
  className?: string;
  text: string;
  delay?: string;
}) {
  const textRef = useRef<HTMLDivElement>(null);

  const [isClamping, setIsClamping] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (!textRef?.current) {
        return;
      }
      setIsClamping(
        textRef.current.scrollHeight > textRef.current.clientHeight ||
          textRef.current.scrollWidth > textRef.current.clientWidth
      );
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className={`${className} group flex align-baseline`}
      onMouseMove={e => {
        const tooltipElement = e.currentTarget.querySelector<HTMLDivElement>('.tooltip');
        if (tooltipElement) {
          tooltipElement.style.transform = `translate(${e.clientX + 12}px, ${e.clientY + 12}px)`;
        }
      }}
    >
      <div className={className} ref={textRef}>
        {text}
      </div>
      {isClamping && (
        <div
          className={`tooltip fixed opacity-0 transition-opacity duration-300 bg-[#1a1a1a] text-[#fdfdfd]
                    group-hover:opacity-100 pointer-events-none shadow-lg p-1
                    rounded-sm border border-gray-200 text-xs max-w-xs z-50 top-0 left-0 ${delay}`}
        >
          {text}
        </div>
      )}
    </div>
  );
}
